export class DashboardDataModel {
    totalOrder: number = 0;
    revenue: number = 0;
    totalCollection: number = 0;
    totalCustomer: number = 0;
    totalInventory: number = 0;
    totalInward: number = 0;
};

export class SaleseEntryCounts {
    searchTable: string = '';
    fromDate: string = '';
    toDate: string = '';
}

export const cardItems = [
    {
        title: "Orders",
        iconClass: "bx bx-cart-alt",
        valueKey: "totalOrder",
        titleForApi: "salesorder",
        isFilter: true,
    },
    {
        title: "Sales Revenue",
        iconClass: "bx bx-line-chart",
        valueKey: "revenue",
        titleForApi: "revenue",
        isFilter: true,
    },
    // {
    //     title: "Customer",
    //     iconClass: "bx bxs-user-circle",
    //     valueKey: "totalCustomer",
    //     titleForApi: "customer",

    //     isFilter: true,
    // },
    {
        title: "Collections",
        iconClass: "bx bx-collection",
        valueKey: "totalCollection",
        titleForApi: "totalCollection",

        isFilter: false,
    },
    {
        title: "Inventory",
        iconClass: "bx bx-collection",
        valueKey: "totalInventory",
        titleForApi: "inventory",

        isFilter: false,
    },
    {
        title: "Inward",
        iconClass: "bx bx-collection",
        valueKey: "totalInward",
        titleForApi: "inward",

        isFilter: false,
    },
];

